import React, { useContext } from 'react'
import {
  getWeekendRange,
  checkSpecialWeek,
  createVenueLocation,
  isIncompleteChampionship,
} from '../../../../Utils'
import { HeaderActions } from './HeaderActions/HeaderActions'
import { SpecialWk, WKHeader } from './weekStyles'
import type { EventGQL } from '../../../../Api'
import { Info } from '../../../../Components/Icons'
import { colors } from '../../../../Components/consts'
import { SeasonContext } from '../../../../Context'
type HeaderParams = {
  week: string
  events: EventGQL[]
}

export const WeekHeader: React.FC<React.PropsWithChildren<HeaderParams>> = ({
  week,
  events,
}) => {
  const { incompleteMarkets } = useContext(SeasonContext)!
  if (events.length === 0) {
    return <div />
  }
  const specialWeek = events.length < 1 ? null : checkSpecialWeek(events[0], true)
  const isChampSeriesWeek =
    events.length > 0 && events[0].seasonSegment === 'champseries'

  const checkEvents = () => {
    const pendingEvent = events.find((ev) => ev.eventStatus === 0)
    if(!pendingEvent) return false
    if(!events[0].location) return false
    return true
  }

  return (
    <>
      {specialWeek && <SpecialWk>{specialWeek}</SpecialWk>}
      <WKHeader>
        <div className="gameInfo">
          {!isChampSeriesWeek && (
            <div className="gameWeek">
              <Info width={20} fill={colors.white} />
            </div>
          )}
          <div className="text">
            {events && (
              <p>
                {isIncompleteChampionship(events[0]?.slugname, events[0]?.week, incompleteMarkets)
                  ? 'TBD'
                  : getWeekendRange(events, incompleteMarkets)}{' '}
                • {createVenueLocation(events[0]?.location, events[0]?.seasonSegment)} •{' '}
                {events[0]?.venue}
              </p>
            )}
          </div>
        </div>
        {checkEvents() && <HeaderActions week={week} events={events} />}
      </WKHeader>
    </>
  )
}
